import React from 'react'
import { Typography } from '@sureco/design-system'
import { PlanBenefitOverrideRuleTemplateKey } from '../enums/plan-benefit-override-rule.enum'

interface Props {
  value: PlanBenefitOverrideRuleTemplateKey | undefined
  onChange: (key: PlanBenefitOverrideRuleTemplateKey) => void
  disabled?: boolean
}

const CARDS = [
  {
    key: PlanBenefitOverrideRuleTemplateKey.PARTIAL_FIELD_UPDATE,
    title: 'Update specific fields',
    subtitle:
      'Only the fields you include will change — everything else stays as-is.',
  },
  {
    key: PlanBenefitOverrideRuleTemplateKey.UPSERT_RULE,
    title: 'Replace or create record',
    subtitle:
      "All fields are required — replaces the existing record entirely, or adds it if it doesn't exist yet.",
  },
] as const

export default function TemplatePicker({ value, onChange, disabled }: Props) {
  if (disabled) {
    const selected = CARDS.find((c) => c.key === value)
    return (
      <div className="templateCardReadOnlyWrap">
        <div className="templateCardRadio">
          <span className="templateRadioDot templateRadioDotSelected" />
        </div>
        <div className="templateCardReadOnlyBody">
          <Typography className="templateCardTitle">
            {selected?.title ?? '—'}
          </Typography>
          {selected?.subtitle && (
            <Typography className="templateCardReadOnlySubtitle">
              {selected.subtitle}
            </Typography>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="templatePickerRow">
      {CARDS.map((card) => {
        const isSelected = value === card.key
        const cardClass = [
          'templateCard',
          isSelected ? 'templateCardSelected' : '',
        ]
          .filter(Boolean)
          .join(' ')

        return (
          <button
            key={card.key}
            type="button"
            className={cardClass}
            onClick={() => onChange(card.key)}
          >
            <div className="templateCardRadio">
              <span
                className={
                  isSelected
                    ? 'templateRadioDot templateRadioDotSelected'
                    : 'templateRadioDot'
                }
              />
            </div>
            <div className="templateCardInner">
              <Typography className="templateCardTitle">
                {card.title}
              </Typography>
              <Typography className="templateCardSubtitle">
                {card.subtitle}
              </Typography>
            </div>
          </button>
        )
      })}
    </div>
  )
}
